module.exports = __webpack_public_path__ + "static/img/t3.46bf6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t3.png
// module id = R3rN
// module chunks = 1